import { useEffect, useState } from "react";
import UploadForm from "../../elements/UploadForm";
import { FilesInterface } from "../../../interface/filesInterface";
import axiosInstance from "../../../services/axios-instance";
import TableFiles from "../../elements/TableFiles";
import { FILES } from "../../../services/endpoints";
import Box from "@mui/material/Box";

const cellNames = {
    cellOne: "Title",
    cellTwo: "Description",
    cellTree: "Type",
    cellFour: "File",
    cellFive: "Remove",
};

const AdminDocumentsScreen = () => {
    const [allFiles, setAllFiles] = useState<FilesInterface[]>([]);

    useEffect(() => {
        async function fetchData() {
            try {
                const responseAllFiles = await axiosInstance.get(FILES);
                setAllFiles(responseAllFiles.data.data);
            } catch (error) {
                console.error(error);
            }
        }
        fetchData();
    }, []);

    return (
        <>
            <UploadForm allFiles={allFiles} setAllFiles={setAllFiles} />
            <Box marginTop={4}>
                <TableFiles
                    data={allFiles}
                    cellNames={cellNames}
                    setAllFiles={setAllFiles}
                />
            </Box>
        </>
    );
};

export default AdminDocumentsScreen;
